import { reaction } from 'mobx';
import { useEffect, useRef, useState } from 'react';

import { useStores } from '../stores';
import useConfig from './useConfig';

/**
 * @todo move to store
 */
export default function useIntentMessageOnInit() {
  const { intentOnInit } = useConfig();
  const { app, bot, chat, chatWindow, network } = useStores();
  const isSent = useRef(false);
  const [isForced, setForced] = useState(false);

  useEffect(
    () =>
      reaction(
        () =>
          !chat.isSpecialMessage &&
          intentOnInit &&
          intentOnInit.enabled &&
          chat.messages.length === 0,
        setForced,
        {
          delay: 300
        }
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [intentOnInit]
  );

  useEffect(() => {
    if (!intentOnInit || (intentOnInit && !intentOnInit.enabled) || chat.isSpecialMessage) {
      return () => {};
    }

    const isChatReady = chatWindow.isOpened && network.isOnline && !network.isSlowConnection;

    if (isForced || !isSent.current) {
      chat.isMessaging = true;
    }

    if (app.sessionId && isChatReady && (isForced || !isSent.current)) {
      bot.runIntentOnInit();

      isSent.current = true;
      setForced(false);
    }

    if (chatWindow.isClosed) {
      isSent.current = false;
    }

    return () => {};
  }, [
    app.sessionId,
    bot,
    chat,
    chat.isMessaging,
    chat.isSpecialMessage,
    chatWindow.isClosed,
    chatWindow.isOpened,
    intentOnInit,
    isForced,
    network.isOnline,
    network.isSlowConnection
  ]);
}
